import { Absence } from "../../../__generated__/graphql";
import React, { useCallback, useMemo } from "react";
import { useI18n } from "../../../hooks/i18n-hooks";

import VStack from "../../../ui_atoms/VStack";
import ListGroup from "../../ListGroup";
import Headline from "../../Headline";
import Gap from "../../../ui_atoms/Gap";
import { useDateRangeFormatter } from "../../../hooks/date";

type PayrollBreakdownAbsencesProps = {
    absences: Array<Absence>;
};

const PayrollBreakdownAbsences: React.FC<PayrollBreakdownAbsencesProps> = ({ absences }) => {
    const i18n = useI18n();
    const formatDateRange = useDateRangeFormatter();
    const buildDescription = useCallback(
        (absence: Absence) => {
            const d = formatDateRange(new Date(absence.start), new Date(absence.end), "long");
            if (absence.comment) {
                return `${d}\n\n${absence.comment}`;
            } else {
                return `${d}`;
            }
        },
        [formatDateRange],
    );
    const items = useMemo(
        () =>
            absences.map((absence) => {
                return {
                    value: absence.id,
                    title: i18n.t(`absence.type.${absence.type}`),
                    description: buildDescription(absence),
                };
            }),
        [absences, buildDescription, i18n],
    );
    if (items.length === 0) {
        return null;
    }
    return (
        <VStack>
            <Gap gap={1} />
            <VStack h="2/3">
                <Headline h="2">{i18n.t("payroll_breakdown.absence_days_title")}</Headline>
            </VStack>
            <ListGroup items={items} />
        </VStack>
    );
};

export default PayrollBreakdownAbsences;
